export default class Privacy {
  constructor() {
    this.privacyButton = document.getElementById("privacy-settings")
    this.cookieBanner = document.querySelector("cookie-banner")

    if (this.privacyButton && this.cookieBanner) {
      this.privacyButton.addEventListener("click", () => {
        this.cookieBanner.promptForConsent()
      })
    }
  }
}
